<template>
    <AdminLayout>
      <MainIndex />
      <div class="pb-16"></div>
    </AdminLayout>
  </template>
<script>
import AdminLayout from '@/layouts/AdminLayout.vue';
import MainIndex from '@/components/admin/tickets/MainIndex.vue';

export default {
  name: 'TicketsView',
  components: {
    AdminLayout,
    MainIndex,
  },
};
</script>
